export async function fetcher( url: string, options: Record<string, any> ) {
  try {
    const response = await fetch( url, options );
    const responseJson = await response.json();
    return responseJson;
  } catch ( error ) {
    return error;
  }
}
